<template>
  <div class="relative">
    <div class="cisSticky">
      <button
        type="button"
        style="position: absolute; right: 130px; margin-top: 10px;"
        class="bg-tawnyorange-400 text-white px-3 py-2 text-sm border-white border-4"
        @click="toggleProductRegisterModal(productName)"
      >
        Register for download
      </button>
      <a
        style="position: absolute; right: 10px; margin-top: 10px;"
        class="bg-tawnyorange-400 text-white px-3 py-2 text-sm border-white border-4"
        href="http://support.pipefish.com.au/2401-pipefish-knowledge-base"
        target="_blank"
      >
        Get support
      </a>
    </div>

    <!-- What is it? -->
    <ContentSection skew="none" id="products" class="z-0 py-24 pt-10 mt-5 bg-white my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">What is it?</h2>
          <p class=" my-3 text-lg leading-7">
            CI Synchronizer is a Freeware, ServiceNow scoped application that integrates your
            on-premises edition of Lansweeper with your ServiceNow instance.
          </p>
          <div class="videoContainer">
            <iframe
              src="//www.youtube.com/embed/-nKAdDPCkFU"
              frameborder="0"
              allowfullscreen
              class="video"
            ></iframe>
          </div>
        </div>
      </div>
    </ContentSection>

    <!-- Why do I need it? -->
    <ContentSection skew="left" id="products1" class="z-0 py-24 bg-grey-100 my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">Why do I need it?</h2>
          <p class="my-3 text-lg leading-7">
            Lansweeper discovers and maintains comprehensive information about your IT assets and
            system topology. By integrating Lansweeper with your CMDB, the depth, breadth and
            accuracy of your Configuration Item data will improve out of sight.
          </p>
          <br />
          <p class="my-3 text-lg leading-7">
            You have already discovered all the assets contained in the Lansweeper database… why not
            leverage them directly in your CMDB?
          </p>
        </div>
      </div>
    </ContentSection>

    <!-- What does it do? -->
    <ContentSection skew="left" id="products1" class="z-0 py-24 bg-white my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">What does it do?</h2>
          <p class="my-3 text-lg leading-7">
            CI Synchronizer synchronizes Lansweeper discovered asset data into the ServiceNow CMDB
            creating and maintaining a rich set of CMDB Configuration items and relationships.
          </p>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/a.png" style="height: 100%" />
            </div>
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/b.png" style="height: 100%" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>

    <!-- How does it work? -->
    <ContentSection skew="right" id="products1" class="z-0 py-24 bg-grey-100 my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">How does it work?</h2>
          <p class="my-3 text-lg leading-7">
            CI Synchronizer connects to an on-premises instance of Lansweeper via a ServiceNow
            Mid-Server. SQL Server queries are issued directly to the Lansweeper database to extract
            asset information and relationships between assets. Records are imported into ServiceNow
            using import sets and transform maps.
          </p>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/c.png" style="height: 100%" />
            </div>
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/d.png" style="height: 100%" />
            </div>
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/e.png" style="height: 100%" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>

    <!-- What if I already have some of the same assets already created in my ServiceNow CMDB? -->
    <ContentSection skew="right" id="products1" class="z-0 py-24 bg-white my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">
            What if I already have some of the same assets already created in my ServiceNow CMDB?
          </h2>
          <p class="my-3 text-lg leading-7">
            The synchronization process takes full advantage of the ServiceNow Identification and
            Reconciliation Engine (IRE) and Data Normalization modules to ensure the synchronized
            data is not duplicated and is created consistently according to your CMDB data controls.
          </p>
        </div>
      </div>
    </ContentSection>

    <!-- How comprehensive is it? -->
    <ContentSection skew="left" id="products1" class="z-0 py-24 bg-grey-100 my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">
            How comprehensive is it?
          </h2>
          <p class="my-3 text-lg leading-7">
            CI Synchronizer integrates a comprehensive set of asset types into their corresponding
            CI classes:
          </p>
          <ul class="my-3 text-lg leading-7 list-disc ml-10">
            <li>IP Firewall</li>
            <li>IP Router</li>
            <li>IP Switch</li>
            <li>Linux Server</li>
            <li>MS SQL Database</li>
            <li>MS SQL Instance</li>
            <li>Windows PC</li>
            <li>Software package</li>
            <li>Unix Server</li>
            <li>Windows Cluster Node</li>
            <li>Windows Server</li>
          </ul>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/f.png" style="height: 100%" />
            </div>
          </div>
          <p class="my-3 text-lg leading-7">
            Related record types are also created for internal components created against
            computer-based assets:
          </p>
          <ul class="my-3 text-lg leading-7 list-disc ml-10">
            <li><span>Memory Modules</span></li>
            <li><span>Network Adapters</span></li>
            <li><span>Storage Devices</span></li>
            <li><span>Installed software packages for Windows Servers and PCs</span></li>
          </ul>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/g.png" style="height: 100%" />
            </div>
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/h.png" style="height: 100%" />
            </div>
          </div>
          <p class="my-3 text-lg leading-7">
            Several CMDB relationships are also derived from Lansweeper data:
          </p>
          <ul class="my-3 text-lg leading-7 list-disc ml-10">
            <li><span>Windows Server Cluster to Member Servers</span></li>
            <li><span>SQL database to SQL Server Instance to Windows Server/PC</span></li>
            <li><span>Network topology derived via switch port mappings.</span></li>
            <li><span>SQL Server Cluster to Member Servers</span></li>
          </ul>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/i.png" style="height: 100%" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>

    <!-- What is included with the application? -->
    <ContentSection skew="left" id="products1" class="z-0 py-24 bg-white my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">
            What is included with the application?
          </h2>
          <p class="my-3 text-lg leading-7">
            A Getting Started page which guides you through the setup and operational functions of
            CI Synchronizer.
          </p>
          <p class="my-3 text-lg leading-7">
            A ServiceNow dashboard which provides an overview of the synchronized record counts by
            CI class and historical details of synchronization executions.
          </p>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/j.png" style="height: 100%" />
            </div>
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/k.png" style="height: 100%" />
            </div>
          </div>
          <p class="my-3 text-lg leading-7">
            A configuration page which provides for environment-specific setup.
          </p>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/l.png" style="height: 100%" />
            </div>
          </div>
          <p class="my-3 text-lg leading-7">
            An execution page which allows for the selection of Asset types to be synchronized.
          </p>
          <div class="image-group ">
            <div class="image-container">
              <img v-img:group-1 src="/img/products/CISynchronizer/m.png" style="height: 100%" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>

    <!-- How can I get the application? -->
    <ContentSection skew="left" id="products1" class="z-0 py-24 bg-grey-100 my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">
            How can I get the application?
          </h2>
          <p class="my-3 text-lg leading-7">
            By registering on the Pipefish website
            <a
              href="#"
              class="text-grey-700 underline hover:text-astralblue-700"
              @click="toggleProductRegisterModal(productName)"
              >here</a
            >
            you can download and start using the product immediately.
          </p>
          <p class="my-3 text-lg leading-7 mt-6">
            <strong> Important note: </strong>
          </p>
          <p class="my-3 text-lg leading-7">
            CI Synchronizer will create <strong> three (3) </strong> custom tables once deployed.
            You will need to consider this custom table requirement and your ServiceNow subscription
            allotment accordingly.
          </p>
          <button
            type="button"
            class="button button--primary relative bg-regalblue-500"
            @click="toggleProductRegisterModal(productName)"
          >
            Register for Download
          </button>
        </div>
      </div>
    </ContentSection>

    <!-- Support -->
    <ContentSection skew="left" id="products1" class="z-0 py-24 bg-white my-0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="heading-two text-grimacepurple-600">
            Support
          </h2>
          <p class="my-3 text-lg leading-7">
            You can search our knowledge base or submit a support request via the
            <a
              href="http://support.pipefish.com.au/2401-pipefish-knowledge-base"
              class="text-grey-700 underline hover:text-astralblue-700"
              target="_blank"
              >product support portal</a
            >.
          </p>

          <!-- <iframe
            src="https://pipefish.supportbee.com/web_tickets/new?embed=true&locale=en&captcha=true"
          /> -->
        </div>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/ContentSection.vue';
export default {
  name: 'Products',
  components: {
    ContentSection
  },
  props: ['productName'],
  data: function() {
    return {
      // productName: this.productName
    };
  },
  methods: {
    toggleProductRegisterModal: function(title) {
      this.Store.toggleProductRegisterModal(title);
    }
  },
  computed: {},

  mounted() {
    // // Display the SupportBee Widget
    // (function(d, src) {
    //   var s = d.createElement('script');
    //   s.src = src;
    //   s.async = true;
    //   s.onload = function() {
    //     new SupportBeeHive({ company: 'pipefish' }).init({
    //       widget: 'kb',
    //       site: '2401-pipefish-knowledge-base',
    //       theme: '#6c205d',
    //       launcher: { position: 'bottom-right', hint: 'Help Docs' }
    //     });
    //   };
    //   d.head.appendChild(s);
    //   d.head.removeChild(s);
    // })(document, '//d3932137p5ikt7.cloudfront.net/widget_v4/hive.js');
  },

  // Remove the SupportBee Widget when navigating away
  beforeDestroy() {
    const sbElement = document.getElementById('supportbee-hive-frame');

    if (sbElement) {
      const elementToDelete = sbElement.parentNode.parentNode;
      elementToDelete.remove();
    }
  }
};
</script>

<style lang="scss">
.cisSticky {
  z-index: 99999;
  height: 50px;
  position: absolute;
  top: -30px;
  right: 0px;
  width: 300px;
}
.image-group {
  display: flex;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.image-container {
  flex-grow: 1;
  flex-basis: 0;
  padding: 0.75rem;
  background-color: #e5e5e5;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}
.button {
  margin-top: 2.5rem;
}

.sect-break {
  margin-top: 5rem;
}

.image-group img {
  margin: auto;
  width: 100%;
  height: unset !important;
}
.videoContainer {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
